import React, { useState } from 'react';

function SortButton({ onSort, colourBlindMode }) {
  const [isOpen, setIsOpen] = useState(false);

  const getBackgroundColor = (colourBlindMode) => {
    switch (colourBlindMode) {
        case true:
            return "bg-[#FFF5EB]"
        default:
            return "bg-[#FFF6E0]";
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const dropdownOptions = [
    'Low to Urgent',
    'Urgent to Low',
    'Recent to Oldest',
    'Oldest to Recent',
    'Default',
  ];

  return (
    <div className="relative">
      <button
        className={`${getBackgroundColor(colourBlindMode)} px-4 py-2 rounded-full  flex items-center sm:px-6 md:px-8 lg:px-10 xl:px-12 text-lg`}
        onClick={toggleDropdown}
      >
        Sort
        <i className={`fas fa-arrow-down-short-wide ml-2 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>
      {isOpen && (
        <div className={`${getBackgroundColor(colourBlindMode)} absolute z-10 mt-2 py-2 w-40 rounded-lg shadow-lg`}>
          {dropdownOptions.map((option, index) => (
            <div
              key={index}
              className={`${getBackgroundColor(colourBlindMode)} px-4 py-2 hover:border-black hover:border-b cursor-pointer`}
              onClick={() => onSort(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortButton;
